import MyAxios from "@/utilize/MyAxios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
export const useDeleteRole = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (roleName: string) =>
      MyAxios?.delete(`/acl`, { data: { name: roleName } }),
    onSuccess: () => {
      queryClient.prefetchQuery({ queryKey: ["TrioRoles"] });
    },
  });
};
